import { render, staticRenderFns } from "./keterlibatan_pegawai.vue?vue&type=template&id=cb0b24ae"
import script from "./keterlibatan_pegawai.vue?vue&type=script&lang=js"
export * from "./keterlibatan_pegawai.vue?vue&type=script&lang=js"
import style0 from "./keterlibatan_pegawai.vue?vue&type=style&index=0&id=cb0b24ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports